<template>
  <q-page class="flex column page-layout ">
    <q-inner-loading :showing="loading" class="fullscreen">
      <q-spinner size="50px" color="secondary" />
    </q-inner-loading>
    <section
      :class="
        article.categoryName === 'Game of the Month'
          ? 'news-item'
          : 'news-item--full-width'
      "
    >
      <article class="news-article">
        <div class="news-article__image">
          <div
            class="news-article__background-image"
            :style="{ 'background-image': 'url(' + article.imageUrl + ')' }"
          />
          <div class="news-article__mask" />

          <q-img
            class="news-article__main-image"
            :src="article.imageUrl"
            :alt="article.imageAlt"
            :title="article.imageAlt"
            spinner-color="white"
            contain
          />
        </div>

        <header class="news-article__heading">
          <q-btn
            unelevated
            round
            outline
            dense
            icon="chevron_left"
            to="/latest-news"
            class="back-button"
            size="sm"
          />
          <h1>{{ article.title }}</h1>
        </header>

        <div class="news-article__date">
          <span class="published">{{
            formatDateTime(article.publishedDate)
          }}</span>
        </div>
        <div
          class="news-article__body"
          v-html="formatMarkdownToHtml(article.content)"
        />
      </article>
      <aside
        class="sidebar"
        v-if="article.categoryName === 'Game of the Month'"
      >
        <div class="sidebar-game ">
          <div class="sidebar-game__heading sidebar__heading">Game</div>
          <div class="sidebar-game__image">
            <img
              :src="article.imageUrl"
              :alt="article.imageAlt"
              :title="article.imageAlt"
            />
          </div>
          <div class="sidebar-game__game-title">
            {{ article.gameTitle }}
          </div>
          <div class="sidebar-game__game-volatility">
            <div class="subheading">
              <q-icon name="swap_vert" /> <span>Volatility</span>
            </div>
            <span class="value">{{ article.volatility }}</span>
          </div>
          <div class="sidebar-game__game-rtp">
            <div class="subheading">
              <q-icon name="person_outline" /><span>RTP</span>
            </div>
            <span class="value">{{ formatPercentage(article.RTP) }}</span>
          </div>
        </div>
      </aside>
    </section>
  </q-page>
</template>

<script>
import { formatDateTime } from "@/utils/formatDate";
import { formatPercentage } from "@/utils/formatPercentage";
import {
  getStrapiContent,
  formatMarkdownToHtml,
} from "@/services/strapi-content/strapiContent";
export default {
  name: "NewsItem",
  data() {
    return {
      article: {},
      loading: true,
      articleId: this.$route.params.id,
    };
  },
  methods: {
    formatDateTime,
    formatPercentage,
    formatMarkdownToHtml,
    fetchNewsItem() {
      const payload = "news-items/" + this.articleId;
      getStrapiContent(payload)
        .then((response) => {
          if ((response && response.data) || {}) {
            const data = response.data;
            const formattedArticle = {
              title: data.Title || null,
              categoryName: (data.NewsCategory && data.NewsCategory.Name) || null,
              imageUrl: (data.Image && data.Image.url) || null,
              imageAlt: (data.Image && data.Image.name) || null,
              publishedDate: data.published_at || null,
              gameTitle: data.GameTitle || null,
              rtp: data.RTP || null,
              volatility: data.Volatility || null,
              id: data.id || null,
              launchType: data.launch_type || null,
              content: data.Body || null,
            };
            this.article = formattedArticle;
            this.loading = false;
          }
        })
        .catch((error) => {
          this.errors.push(error);
          this.loading = false;
        });
    },
  },

  mounted() {
    this.fetchNewsItem();
  },
};
</script>